import { createSlice } from '@reduxjs/toolkit';

export const fpostSlice = createSlice({
    name: 'friend_post',
    initialState: {
        loading: true,
        data: {},
        post_data: [],
        error: false,
    },
    reducers: {
        FPOST_FETCH_START: (state) => {
            state.loading = false
        },
        FPOST_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.data = action.payload
            state.post_data = action.payload.all_post
        },
        FPOST_FETCH_SUCCESS_LOAD: (state, action) => {
            state.loading = false
            state.data = action.payload
            state.post_data = [...state.post_data, ...action.payload.all_post]
        },
        EDIT_FPOST_FETCH_SUCCESS: (state, action) => {
            state.loading = false;
            const updatedPostIndex = state.post_data.findIndex(post => post.id === action.payload.id);
            if (updatedPostIndex !== -1) {
                const updatedPostArray = [...state.post_data];
                updatedPostArray[updatedPostIndex] = action.payload;
                state.post_data = updatedPostArray;
            }
        },
        ADD_FPOST_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.data = action.payload
            state.post_data = [action.payload, ...state.post_data]
        },
        FPOST_FETCH_COMMENT_ADDON: (state, action) => {
            state.loading = false
            state.post_data = state.post_data.map((post) =>
                post.id === action.payload.post_id
                    ? { ...post, totalComments: (post.totalComments || 0) + 1, last_comments: [...post.last_comments, action.payload] }
                    : post
            )
        },

        DELETE_FPOST_COMMENT: (state, action) => {
            state.loading = false
            state.post_data = state.post_data.map((post) =>
                post.id === action.payload.post_id
                    ? {
                        ...post,
                        totalComments: Math.max(0, (post.totalComments || 0) - 1),
                        last_comments: post.last_comments.filter((com) => com.id !== action.payload.comment_id)
                    }
                    : post
            )
        },

        DELETE_FPOST: (state, action) => {
            const filterPosts = state.post_data.filter(
                (post) => post.id !== action.payload
            );
            state.loading = false
            state.post_data = filterPosts
        },

        ADD_FPOST_REPLY: (state, action) => {
            state.post_data = state.post_data.map((post) =>
                post.id === action.payload.post_id
                    ? {
                        ...post,
                        last_comments: post.last_comments.map((comment) =>
                            comment.id === action.payload.comment_id
                                ? { ...comment, comment_reply: [...(comment.comment_reply || []), action.payload] }
                                : comment
                        )
                    }
                    : post
            )
        },

        DELETE_FPOST_REPLY: (state, action) => {
            state.post_data = state.post_data.map((post) =>
                post.id === action.payload.post_id
                    ? {
                        ...post,
                        last_comments: post.last_comments.map((com) =>
                            com.id === action.payload.comment_id
                                ? { ...com, comment_reply: (com.comment_reply || []).filter(reply => reply.id !== action.payload.comment_reply_id) }
                                : com
                        )
                    }
                    : post
            )
        },

        FPOST_FETCH_ERROR: (state) => {
            state.error = true
        },
        FPOST_LIKE_UPDATE: (state, action) => {
            state.post_data = state.post_data.map((post) =>
                post.id === action.payload.post_id
                    ? { ...post, totalLikes: action.payload.likes_count, is_like: action.payload.is_like }
                    : post
            )
        }
    }
});

export const { EDIT_FPOST_FETCH_SUCCESS, FPOST_FETCH_START, DELETE_FPOST_REPLY, ADD_FPOST_FETCH_SUCCESS, FPOST_FETCH_ERROR, FPOST_FETCH_SUCCESS, FPOST_FETCH_SUCCESS_LOAD, FPOST_FETCH_COMMENT_ADDON, ADD_FPOST_REPLY, DELETE_FPOST_COMMENT, DELETE_FPOST, FPOST_LIKE_UPDATE } = fpostSlice.actions;
export default fpostSlice.reducer;